<div class="media">
    <swb-file-list></swb-file-list>
</div>